import classNames from 'classnames';
import { createElement, JSX } from 'react';
import atHeaderVariants from './at-header.variants';
import { IAtHeaderProps } from './at-header.types';

/**
 * `AtHeader` is a semantic heading component that renders the correct heading tag (`h1`–`h6`)
 * with consistent typography styles using Tailwind Variants.
 *
 * This component is used for all headings in the system and allows for an alternate visual style
 */

export const AtHeader = ({
  children,
  element = 'h2',
  variant,
  alt = false,
  className,
}: IAtHeaderProps): JSX.Element => {
  const jsxCode = createElement(
    element || 'h2',
    {
      className: classNames(
        atHeaderVariants({ size: variant || element, alt }),
        className,
      ),
    },
    children,
  );

  return jsxCode;
};
